export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

export const showLoading = () => ({
	type: SHOW_LOADING,
});

export const hideLoading = () => ({
	type: HIDE_LOADING,
});
